<template>
  <div class="offcanvas-body">
    <div class="h-100 d-flex flex-column justify-content-between">
      <div>
        <p class="text-subtitle mb-2">Seu gênero</p>
        <RadioInput name="gender" :options="options" :model="v$.form.gender" />
        <hr />
        <p class="text-subtitle mb-2">Gêneros que você atende</p>
        <RadioInput name="accepted_gender" :options="acceptedGenderOptions" :model="v$.form.accepted_gender" />
      </div>
      <FormButton
        :form="v$.form"
        label="Concluir"
        :loading="submitting"
        @onClick="submit"
        :disabled="v$.invalid"
      />
    </div>
  </div>
</template>

<script lang="ts">
import GenderController from "./GenderController";
export default GenderController;
</script>
